<template>
  <v-container>
    <v-row>
      <v-col cols="3">
        <v-text-field
          id="warWhomsEditedItemDescription"
          class="war-whoms-edit-item-description"
          label= "Description"
          v-model="editedItem.description"
          v-uppercase=globalSettingItem.conEverythingToCaps
          :autofocus="true"
        ></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="warWhomsEditedItemFiscalYear"
          class="war-whoms-edit-item-fiscal-year"
          label= "Fiscal Year"
          v-model="editedItem.fiscalYear"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'WhomsEditedItem',
  mixins: [GlobalToCaps],
  components: {
  },
  props: {
    baseCrudKey: {
      type: String,
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'item',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    changes() {
      return this.editedItem.changes || [];
    },
  },
  methods: {
    ...mapActions('war/whom', [
      'loadWhoms',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItem',
    ]),
  },
};
</script>
